// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { quartersToYears as fn } from "../quartersToYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const quartersToYears = convertToFP(fn, 1);

// Fallback for modularized imports:
export default quartersToYears;
